import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isFeatureEnabled } from 'owa-feature-flags';
import { INTERESTING_CALENDARS_FEATURE } from '../FeaturesFlagName';

export default function isInterestingCalendarsEnabled() {
    let userConfiguration = getUserConfiguration();
    return (
        isFeatureEnabled(INTERESTING_CALENDARS_FEATURE) &&
        userConfiguration &&
        userConfiguration.PolicySettings &&
        userConfiguration.PolicySettings.InterestingCalendarsEnabled
    );
}
